import { useState } from 'react';
import { api } from '../services/api.js';
import { useAuth } from '../hooks/useAuth.jsx';
import { validarLink, validarNome, validarNomeOpcional, validarSlug, MENSAGENS_ERRO } from '../utils/validators.js';

export default function LinkForm({ aoCriar }) {
  const { usuario } = useAuth();
  const ehPro = usuario?.plano === 'Plano Pro';

  const [nome, setNome] = useState('');
  const [link, setLink] = useState('');
  const [slug, setSlug] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState(null);
  const [resultado, setResultado] = useState(null);

  async function onSubmit(e) {
    e.preventDefault();
    setErro(null);
    setResultado(null);

    const erroLink = validarLink(link);
    const erroNome = usuario ? validarNome(nome) : validarNomeOpcional(nome);
    const erroSlug = validarSlug(slug);
    const codigoErro = erroLink || erroNome || erroSlug;
    if (codigoErro) {
      setErro(MENSAGENS_ERRO[codigoErro] || 'Dados inválidos.');
      return;
    }

    setEnviando(true);
    try {
      const criado = await api.linksCriar({
        nome,
        link,
        nome_personalizado: slug || undefined,
      });
      setResultado(criado);
      setNome('');
      setLink('');
      setSlug('');
      aoCriar?.(criado);
    } catch (err) {
      setErro(MENSAGENS_ERRO[err.codigo] || err.message || 'Falha ao criar.');
    } finally {
      setEnviando(false);
    }
  }

  async function copiar() {
    if (resultado) {
      await navigator.clipboard.writeText(resultado.short_link);
    }
  }

  return (
    <section aria-labelledby="titulo-criar-link">
      <h2 id="titulo-criar-link" className="h4 mb-3">Criar um novo link</h2>
      <form onSubmit={onSubmit} noValidate>
        {usuario && (
          <div className="mb-3">
            <label htmlFor="campo-nome" className="form-label">Nome <span className="text-secondary">(ex: Instagram)</span></label>
            <input
              id="campo-nome"
              className="form-control"
              type="text"
              value={nome}
              maxLength={80}
              required
              autoComplete="off"
              onChange={(e) => setNome(e.target.value)}
              aria-describedby="dica-nome"
            />
            <div id="dica-nome" className="form-text">Use um nome curto que te ajude a identificar o link.</div>
          </div>
        )}

        <div className="mb-3">
          <label htmlFor="campo-link" className="form-label">Link original</label>
          <input
            id="campo-link"
            className="form-control"
            type="url"
            value={link}
            maxLength={2048}
            required
            placeholder="https://exemplo.com/algo-bem-grande"
            onChange={(e) => setLink(e.target.value)}
          />
        </div>

        {ehPro && (
          <div className="mb-3">
            <label htmlFor="campo-slug" className="form-label">Nome personalizado <span className="text-secondary">(opcional)</span></label>
            <input
              id="campo-slug"
              className="form-control"
              type="text"
              value={slug}
              maxLength={30}
              pattern="[a-zA-Z0-9_-]{3,30}"
              autoComplete="off"
              onChange={(e) => setSlug(e.target.value)}
              aria-describedby="dica-slug"
            />
            <div id="dica-slug" className="form-text">3 a 30 caracteres: letras, números, _ ou -.</div>
          </div>
        )}

        <button type="submit" className="btn btn-primary" disabled={enviando}>
          {enviando ? 'Criando…' : 'Encurtar link'}
        </button>
      </form>

      <div role="status" aria-live="polite" className="mt-3">
        {erro && <div className="alert alert-danger" role="alert">{erro}</div>}
        {resultado && (
          <div className="alert alert-success">
            <div className="mb-2">
              <strong>Link criado!</strong>
              {resultado.nome && <span className="ms-2 text-secondary">— {resultado.nome}</span>}
            </div>
            <a href={resultado.short_link} target="_blank" rel="noreferrer">{resultado.short_link}</a>
            <button type="button" className="btn btn-sm btn-outline-light ms-2" onClick={copiar} aria-label="Copiar link curto">Copiar</button>
          </div>
        )}
      </div>
    </section>
  );
}
